export default {
  CMS: [],
  content: {},
};
